module.exports = __webpack_public_path__ + "assets/img/guide.56632be5.png";